// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/follow-us-on-instagram-2-2-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const followUsOnInstagram222DE: PageEntry = {
  id: "post.follow-us-on-instagram-2-2-2",
  locale: "de",
  slug: "follow-us-on-instagram-2-2-2",
  seo: {
    title: "Neustadt hilft der Ukraine | Dietz GmbH",
    description: "Neustadt hilft der Ukraine",
  },
  type: "post",
  h1: "Neustadt hilft der Ukraine",
  blocks: [
    { kind: "heading", level: 2, text: "Neustadt hilft der Ukraine" },
    { kind: "paragraph", text: "Die Folgen des Krieges in der Ukraine sind nicht greifbar und gefühlt weit weg. Erstmals seit über 60 Jahren aber gibt es Krieg in Europa. Das Leid der Menschen im Kriegsgebiet ist enorm." },
    { kind: "paragraph", text: "Wir versuchen hier mit unseren begrenzten Mitteln zu helfen. Wir haben direkten Kontakt in die Stadt Perejaslaw, rund 90km südlich von Kiew und wollen direkt den Menschen vor Ort helfen." },
    { kind: "paragraph", text: "Durch unseren Kontakt können wir auch direkt liefern – ohne Umwege direkt zu den am schlimmsten Betroffenen." },
    { kind: "paragraph", text: "Wir haben uns entschlossen die Familien dort über „Care-Pakete“ zu versorgen." },
    { kind: "paragraph", text: "Der Einkaufswert eines Paketes entspricht € 50,-" },
    { kind: "heading", level: 2, text: "Wie können Sie helfen:" },
    { kind: "paragraph", text: "Durch Überweisung eines Betrages von € 50,- oder einem Vielfachen davon auf das Konto" },
    { kind: "paragraph", text: "IBAN DE02 7835 0000 0092 0394 52 BIC BYLADEM1COB Verwendungszweck: NEUSTADT HILFT" },
    { kind: "heading", level: 3, text: "Jedes Paket hilft einer leidenden Familie – helfen Sie mit – unterstützen Sie uns!" }
  ],
};
